import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table", true)!
  const _component_EmptyData = _resolveComponent("EmptyData")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createVNode(_component_Table, {
      slotData: _ctx.classes,
      columns: _ctx.columns,
      loading: _ctx.loading,
      filters: _ctx.filters,
      params: _ctx.params,
      customActions: true,
      onOnFilter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterFor())),
      onOnClearFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilter())),
      onOnPaginate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paginate($event)))
    }, {
      filters: _withCtx(() => [
        (_ctx.filterType === 'name')
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 0,
              modelValue: _ctx.filters.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      actions: _withCtx(({ columnProps }) => [
        _createVNode(_component_Button, {
          class: "btn-simple flex gap-2",
          onClick: _withModifiers(($event: any) => (_ctx.showClassCalendar(columnProps)), ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { name: "bi-calendar-event" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Ver calendário", en: "See calendar" })), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["slotData", "columns", "loading", "filters", "params"]),
    _createVNode(_component_EmptyData, {
      data: !_ctx.classes || _ctx.classes.length == 0,
      label: _ctx.emptyState.description,
      image: _ctx.emptyState.image,
      imgSize: "h-40 md:h-64 mt-20",
      msgSize: "md:w-3/12"
    }, null, 8, ["data", "label", "image"])
  ], 64))
}